import { ArrayInput, NumberInput, required, SimpleFormIterator } from "react-admin";
import { settings } from "app";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { Grid, Typography } from "@mui/material";

const TheoreticalForm = () => {
  return (
    <>
      <Typography
        color={"primary"}
        sx={{ textAlign: "center", fontWeight: "bold", margin: "2rem" }}
      >
        Тип на тема: Теоретична
      </Typography>
      <ArrayInput
        source="employees"
        label=""
        defaultValue={[{}]}
      >
        <SimpleFormIterator sx={settings.style.iteratorWithoutGap}>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
            >
              <ProfessorInput
                source="employeeId"
                validate={required()}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <CustomDateInput
                source="dateFrom"
                label="От дата"
                validate={required()}
                noTime
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <CustomDateInput
                source="dateTo"
                label="До дата"
                validate={required()}
                noTime
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <NumberInput
                source="hours"
                label="Часове"
                validate={required()}
                onWheel={e => e.target.blur()}
              />
            </Grid>
          </Grid>
        </SimpleFormIterator>
      </ArrayInput>
    </>
  );
};

export default TheoreticalForm;
